import { Stack, Icon } from "@fluentui/react";

import {
  PlanOfferContainer,
  CarrierLogo,
  PlanName
} from "../PlansOffers/PlanOfferContract/PlanOffer.styles";

import { Plan, PlanOfferItem } from "@/modules/Offers/types/PlansOffers.types";

interface EnergyOfferDescriptionProps {
  selectedPlan: Plan;
  selectedCarrier: PlanOfferItem;
}

export function EnergyOfferDescription({
  selectedPlan,
  selectedCarrier
}: EnergyOfferDescriptionProps): JSX.Element {
  return (
    <PlanOfferContainer
      tokens={{ padding: 20 }}
      verticalAlign="center"
      horizontalAlign="center"
    >
      <CarrierLogo
        src={selectedCarrier?.logo}
        alt={selectedCarrier?.name}
        style={{ maxWidth: 300 }}
      />

      <PlanName>{selectedPlan?.name}</PlanName>

      <Stack tokens={{ childrenGap: 15, padding: 20 }}>
        {selectedPlan?.voice && (
          <Stack horizontal verticalAlign="center">
            <Icon
              iconName="LightningBolt"
              style={{
                fontSize: 20,
                marginRight: 15
              }}
            />
            <span className="ms-fontSize-14">{selectedPlan.voice}</span>
          </Stack>
        )}
      </Stack>
    </PlanOfferContainer>
  );
}
